module.exports = __webpack_public_path__ + "static/media/desktop15.65424d9d.png";